import type { FaireProductEntity } from "../../entity_types/product";

export const p_2r2z8pkpkf: FaireProductEntity = {
  token: "p_2r2z8pkpkf",
  type: "product",
  name: "Women's Ultra Soft Ribbed Plush 38\" Wrap Robe",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/8b2503169917ef518b05d374de5512feadf1d090ac9d0368bf8dbb2ea933bfbc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/faf522b18c32e05aee9f6ffca5967ef3212573ebcaa4507deec25643e9205783.png",
    "https://cdn.faire.com/fastly/2bab43b19c1bcba7e98c7ffba34bfd9dfc29a48837a83adb663a75e72ecf33dd.jpeg",
    "https://cdn.faire.com/fastly/4fbfbfb25d38ce1dc0b154604c9bc08b9eb027546484cd9e1b57ede780641a96.png",
    "https://cdn.faire.com/fastly/c0043605187cd05df91117e371e2059f346372b96f8ff4798a78e8e88c99c05e.jpeg",
    "https://cdn.faire.com/fastly/28ed8a3d00f109ad0af7ca7254d6ac68b8294ee32db21ab814bd8376acc00043.png",
    "https://cdn.faire.com/fastly/af8f6d7e81a90b9cda9f495a8dff93bad6a298be981e9174c6356b07ed086a47.jpeg",
    "https://cdn.faire.com/fastly/159f55a0973e0071d8b756732062bfc0d5555931a9a1674b1c7df38973046940.jpeg",
    "https://cdn.faire.com/fastly/0d769a11e8cba3c628912043f0c84cbf6b81f1f78139c8423a4bd20b696261d0.jpeg",
    "https://cdn.faire.com/fastly/20691a2aca5dbf16d9310aa0e9e14c1651ad0ef6fc3306ae221e1c09430ff3a1.png",
    "https://cdn.faire.com/fastly/7a611261d6f538d7a1025f63e19a299ea4156749644fb139231ec67541d8fdb3.png"
  ],
  priceDollars: 60,
  description: "Maximize your downtime and step into the season with Softies Women's Marshmallow Wrap Robe. Fluffy like a marshmallow and soft as a cloud, this robe’s signature blend of fabric has become a legend among those who love to lounge. Playful and pretty, the knee-length hem and ribbed knit fabric work well on their own, over jammies or even layered on top of your favorite cozy tees and leggings. Either way, you won’t want to take this lovely, lounging must-have off! A detached belt allows for a customized fit, and double pockets provide convenience when you’re popping from room to room or curled up on the couch with a good book and your favorite drink.",
  tags: [],
  msrpDollars: 120,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:10.841Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
